<obg-m-dialog-layout [titleText]="title">
	<obg-m-iaui-verification-container (done)="onDone($event)"></obg-m-iaui-verification-container>
</obg-m-dialog-layout>
